// Import global SCSS so Webpack compiles and extracts to style.css
import '../scss/components.scss';

'use strict'

jQuery(document).ready(function ($) { 

    // Header Sticky 
    $(this).scrollTop(0)
    $(window).scroll(function () {
        if ($(this).scrollTop() > 15) {
            $('header.site-header').addClass("is-sticky");
        } else {
            $('header.site-header').removeClass("is-sticky");
        }
    });

  // check if site-header offset top is greater than 50
  if($('header.site-header').offset().top > 50) {
      $('header.site-header').addClass("is-sticky");
  } 

  

    $("#comments .comment-list").toggle();

    $("#comments .drop-down-comments").on('click', ()=>{
        $("#comments .comment-list").toggle({
            effect: "slide",
            easing: "linear", //swing
            duration: 400, 
        });
        $("#comments .drop-down-comments").toggleClass("active")
    })


    //Search results page load more ajax
    $(".search .load-more").on('click', function(){
        let button = $(this).closest(".wp-block-buttons");
        var page = button.data('page');
        var max = button.data('max');
        var query = button.data('query');
        const postsWrapper = $(".search .search-result-post-wrapper");
        const category =  postsWrapper.data("active-category");
        const order = $('.search-sort-filter-wrapper').attr('data-sort-filter');
    
        $('.search .search-result-post-wrapper').addClass('loading');

        $.ajax({
                url: genpro_obj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'search_results_load_more',
                    page: page,
                    search: query,
                    category : category,
                    order: order
                },
                success: function(response) {
                     page  = page + 1 ;
                     
                    button.data('page', page);

                    if (response.data.end) {
                        button.hide();
                    }
                    $('.search .search-result-post-wrapper').append(response.data.html);
                    $('.search .search-result-post-wrapper').removeClass('loading');

                    
                   
                }
            });
        
    })

    // Sticky Related Stories (script-driven sticky)
    if ($('.sticky-related-posts').length) {
        const $win = $(window);

        function getHeaderOffset() {
            const $hdr = $('header.site-header.is-sticky');
            return $hdr.length ? $hdr.outerHeight() : 0;
        }

        function updateOne($sticky) {
            const topMargin = parseInt($sticky.attr('data-top'), 10) || 24;
            const headerH = getHeaderOffset();
            const fixedTop = headerH + topMargin;

            const $main = $('#main');
            const $mainAlt = $main.length ? $main : $('#primary .site-main');
            if (!$mainAlt.length) return; // no main content to constrain to

            const mainTop = $mainAlt.offset().top;
            const mainBottom = mainTop + $mainAlt.outerHeight();

            const startTop = $sticky.data('startTop') ?? $sticky.offset().top; // cache initial
            if ($sticky.data('startTop') == null) {
                $sticky.data('startTop', startTop);
            }

            const scrollTop = $win.scrollTop();
            const stickyHeight = $sticky.outerHeight(true);
            const currentWidth = $sticky.width();

            if (scrollTop + fixedTop >= startTop) {
                // Fix to viewport
                $sticky.addClass('is-fixed')
                    .css({ position: 'fixed', top: fixedTop + 'px', width: currentWidth });

                // Prevent layout jump
                const $parent = $sticky.parent();
                if (!$parent.data('minHeightSet')) {
                    $parent.css('min-height', stickyHeight);
                    $parent.data('minHeightSet', true);
                }

                // Stop at main bottom
                const bottomOverlap = (scrollTop + fixedTop + stickyHeight) - mainBottom;
                if (bottomOverlap > 0) {
                    $sticky.css({ transform: 'translateY(' + (-bottomOverlap) + 'px)' });
                } else {
                    $sticky.css({ transform: '' });
                }
            } else {
                // Reset
                $sticky.removeClass('is-fixed').css({ position: '', top: '', width: '', transform: '' });
                const $parent = $sticky.parent();
                if ($parent.data('minHeightSet')) {
                    $parent.css('min-height', '');
                    $parent.removeData('minHeightSet');
                }
            }
        }

        function onScrollOrResize() {
            // Disable on small screens where sidebar stacks under content
            if (window.matchMedia('(max-width: 768px)').matches) {
                $('.sticky-related-posts').each(function () {
                    $(this).removeClass('is-fixed').css({ position: '', top: '', width: '', transform: '' });
                    const $parent = $(this).parent();
                    if ($parent.data('minHeightSet')) {
                        $parent.css('min-height', '');
                        $parent.removeData('minHeightSet');
                    }
                });
                return;
            }
            $('.sticky-related-posts').each(function () { updateOne($(this)); });
        }

        // Initial measurements and handlers
        onScrollOrResize();
        let resizeTimer;
        $win.on('scroll', onScrollOrResize);
        $win.on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                // Reset cached startTop as layout might change
                $('.sticky-related-posts').each(function () { $(this).removeData('startTop'); });
                onScrollOrResize();
            }, 100);
        });
    }

    if($('.search-filters').length > 0){
         $(".search-catogories-filter-wrapper .search-category-filter").on("click", function () {
            const categoryPill = $(this);
            const category = categoryPill.data("category");
            const postsWrapper = $(".search .search-result-post-wrapper");
            const activeCategory = postsWrapper.attr("data-active-category");

            if(category === activeCategory){
                return;
            }
            
            categoryPill.closest(".search-catogories-filter-wrapper").find(".search-category-filter").removeClass("active");
            categoryPill.addClass("active");

            const searchTerm = postsWrapper.data("search-term");

            postsWrapper.attr("data-active-category", category);

            postsWrapper.addClass('loading');

            let button = $('.load-more-wrapper')
            const order = $('.search-sort-filter-wrapper').attr('data-sort-filter');

            var container = $('.category-filters');
            var containerOffset = container.offset();
            var itemOffset = categoryPill.offset();
            var scrollLeft = container.scrollLeft();

            var offsetX = (itemOffset.left - containerOffset.left) + (categoryPill.outerWidth() / 2) - (container.width() / 2);

            container.animate({
                scrollLeft: scrollLeft + offsetX,
            }, 300);


            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'search_page_cat_filters',
                    category : category,
                    searchTerm : searchTerm,
                    order: order
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    
                    postsWrapper.removeClass('loading');

                    button.data('page', 2);
                    button.attr('data-page', 2);
                    button.attr('data-max', response.data.max);
                    button.data('max', response.data.max);
                 
                    if (!response.data.end) {
                        button.hide(); 
                    }else{
                         button.show(); 
                    }
                }
            });
            
         });


         $(".search-sort-filter-wrapper .search-sort-filters").on("click", function () {
            $(this).toggleClass("active")
            $(this).children('li:not(.init)').toggleClass("show");
         })

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.search-sort-filters').length) {
                $('.search-sort-filters').children('li:not(.init)').removeClass('show');
                    $('.search-sort-filters').removeClass('active');
            }
        });

        $(".search-sort-filter-wrapper .search-sort-filters li:not(.init)").on("click", function () {
            const currentSortOrder = $('.search-sort-filter-wrapper').attr('data-sort-filter');
            const order = $(this).data('value');

            if (currentSortOrder === order) {
                return;
            }

            var allOptions = $(".search-sort-filter-wrapper .search-sort-filters").children('li:not(.init)');
            const postsWrapper = $('.search-result-post-wrapper');
            allOptions.removeClass('selected');

            $(this).addClass('selected');

            const category = postsWrapper.attr("data-active-category");
            const searchTerm = postsWrapper.data('search-term');
            const postCount = postsWrapper.children().length;
            
            $('.search-sort-filter-wrapper').attr('data-sort-filter', order)

            $(".search-sort-filter-wrapper .search-sort-filters").children('.init').find('.init-text').html($(this).html());
            
            postsWrapper.addClass('loading');
            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'search_order_filters',
                    category : category,
                    searchTerm : searchTerm,
                    order: order,
                    postCount : postCount,
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    
                    postsWrapper.removeClass('loading');

                }
            });


        })
    }

    if($('.post-filters').length > 0){

        $(".post-filters .category-filters .category-filter").on("click", function () {
            const categoryPill = $(this);
            const postsWrapper = $('.wp-block-wwx-advanced-query__posts.archive');

            const category = categoryPill.data("category");
            const subCategory = categoryPill.data("sub-category");
            const activeCategory = postsWrapper.attr("data-active-category");
            
            if(subCategory === activeCategory){
                return;
            }

            categoryPill.closest(".category-filters").find(".category-filter").removeClass("active");
            categoryPill.addClass("active");

            const order = $('.sort-filter-wrapper').attr('data-sort-filter');
            postsWrapper.attr("data-active-category", subCategory);

            postsWrapper.addClass('loading');

            var container = $('.category-filters');
            var containerOffset = container.offset();
            var itemOffset = categoryPill.offset();
            var scrollLeft = container.scrollLeft();

            var offsetX = (itemOffset.left - containerOffset.left) + (categoryPill.outerWidth() / 2) - (container.width() / 2);

            container.animate({
                scrollLeft: scrollLeft + offsetX,
            }, 300);

            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'cat_filters',
                    category : category,
                    sub_category : subCategory,
                    order: order
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    postsWrapper.removeClass('loading');

                    // Ensure state is synced when returning to "All"
                    if (subCategory === 'all') {
                        postsWrapper.attr('data-active-category', 'all');
                        const $filters = $('.post-filters .category-filters');
                        $filters.find('.category-filter').removeClass('active');
                        $filters.find('.category-filter[data-sub-category="all"]').addClass('active');
                    }
                }
            });
        })

        $(".post-filters .sort-filters").on("click", function () {
            $(this).toggleClass("active")
            $(this).children('li:not(.init)').toggleClass("show");
        })

        $(document).on('click', function(event) {
            if (!$(event.target).closest('.sort-filters').length) {
                $('.sort-filters').children('li:not(.init)').removeClass('show');
                    $('.sort-filters').removeClass('active');
            }
        });

        $(".post-filters .sort-filters li:not(.init)").on("click", function () {
            const currentSortOrder = $('.sort-filter-wrapper').attr('data-sort-filter');
            const order = $(this).data('value');

            if(currentSortOrder === order){
                return;
            }
            


            var allOptions = $(".post-filters .sort-filters").children('li:not(.init)');
            const postsWrapper = $('.wp-block-wwx-advanced-query__posts.archive');
            allOptions.removeClass('selected');

            $(this).addClass('selected');

            $(".post-filters .sort-filters").children('.init').find('.init-text').html($(this).html());

            const category = $('.category-filters .category-filter').attr('data-category');
            const subCategory = postsWrapper.attr("data-active-category");
            const postCount = postsWrapper.children().length;
            
            $('.sort-filter-wrapper').attr('data-sort-filter', order)

            postsWrapper.addClass('loading');

            $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'order_filters',
                    category : category,
                    sub_category : subCategory,
                    order: order,
                    postCount : postCount,
                }, 
                success : function(response){
                    postsWrapper.html(response.data.html);
                    
                    postsWrapper.removeClass('loading');

                }
            });

            

        })
    }


    if($('.single-post-share').length > 0){
        $(".share-icon").on("click", function () {
            $(this).closest('.share-wrapper').find('.share-social-icons').toggleClass('active')
        })

         $(document).on('click', function(event) {
            if (!$(event.target).closest(".share-icon").length) {
                $('.share-social-icons').removeClass('active');
            }
        });
    }


        if($('.category-pills-wrapper').length > 0){
             $(".category-pills-wrapper .category-pill").on("click", function () {
                const categoryPillWrapper = $('.category-pills-wrapper');
                const categoryPill = $(this);
                
                const category = categoryPill.data("category");
                const activeCategory = categoryPillWrapper.attr("data-active-category");
            
                if(category === activeCategory){
                    return;
                }
                categoryPillWrapper.find('.category-pill').removeClass('active');
                categoryPill.addClass('active');
                categoryPillWrapper.attr("data-active-category", category)

                // Center the active pill
                centerActivePill(categoryPillWrapper, categoryPill);

                const postsWrapper = $('.wp-block-wwx-featured-home-wrapper');
                postsWrapper.addClass('loading');
                $.ajax({
                    url : genpro_obj.ajaxurl,
                    type : 'POST',
                    data : { 
                        action : 'home_category_tabs', 
                        category : category,
                    }, 
                    success : function(response){
                        postsWrapper.html(response.data.html);
                        postsWrapper.removeClass('loading');
                    }
                });
             });

             // Function to center the active pill
             function centerActivePill(container, activeItem) {
                 var containerOffset = container.offset();
                 var itemOffset = activeItem.offset();
                 var scrollLeft = container.scrollLeft();
                 
                 // Calculate the offset to center the item
                 var offsetX = (itemOffset.left - containerOffset.left) + (activeItem.outerWidth() / 2) - (container.width() / 2);
                 
                 container.animate({
                     scrollLeft: scrollLeft + offsetX,
                 }, 300);
             }

             // Center the initial active pill on page load
             $(document).ready(function() {
                 const initialActive = $('.category-pills-wrapper .category-pill.active');
                 if (initialActive.length > 0) {
                     setTimeout(function() {
                         centerActivePill($('.category-pills-wrapper'), initialActive);
                     }, 100); // Small delay to ensure DOM is fully rendered
                 }
             });
        }


        if($('.load-more-destinations')){
             $(".load-more-destinations").on("click", function () {
                var button = $(this).closest('.load-more-wrapper');
                var page = button.attr('data-page');
                const maxPages = button.attr('data-max');
                const postsWrapper = $('.related-posts-wrapper');
                const categories = postsWrapper.attr('data-categories');

                $('.related-posts').addClass('loading')


                $.ajax({
                url : genpro_obj.ajaxurl,
                type : 'POST',
                data : { 
                    action : 'destinations_post_grid_load_more',
                    categories : categories.replace(/\s+/g, ''),
                    page : page,
                }, 
                success : function(response){
                    $('.related-posts').append(response.data.html);
                    $('.related-posts').removeClass('loading')

                    page++;
                    button.attr('data-page', page);

                    if(page > maxPages){
                        button.hide();
                    }
                }
            });

           
                
             })
        }

        if($('#footer-widgets')) {

            // Footer Accordion Functionality
            function initFooterAccordions() {
                const $footerWidgets = $('.footer-widget-1, .footer-widget-2, .footer-widget-3, .footer-widget-4');
                
                // Check if we're on mobile (768px and below)
                function isMobile() {
                    return $(window).width() <= 768;
                }
                
                // Initialize accordion behavior
                function setupAccordions() {
                    if (isMobile()) {
                        // Mobile: Convert to accordions
                        $footerWidgets.each(function() {
                            const $widget = $(this);
                            const $aside = $widget.find('aside');
                            const $title = $aside.find('.widget-title');
                            const $menuContainer = $aside.find('.menu-plan-your-trip-container, .menu-partners-container, .menu-need-help-container, .menu-travellab-group-container');
                            
                            // Add accordion classes
                            $widget.addClass('footer-accordion');
                            $title.addClass('accordion-trigger');
                            $menuContainer.addClass('accordion-content');
                            
                            // Initially collapse all content on mobile
                            $menuContainer.hide();
                            
                            // Add click handler to title
                            $title.off('click.accordion').on('click.accordion', function() {
                                const $this = $(this);
                                const $currentContent = $this.siblings('.accordion-content');
                                const isOpen = $currentContent.is(':visible');
                                
                                // Toggle current accordion
                                if (isOpen) {
                                    $currentContent.slideUp(300);
                                    $this.removeClass('active');
                                } else {
                                    $currentContent.slideDown(300);
                                    $this.addClass('active');
                                }
                            });
                            
                            // Add cursor pointer to title
                            $title.css('cursor', 'pointer');
                        });
                    } else {
                        // Desktop: Remove accordion behavior
                        $footerWidgets.each(function() {
                            const $widget = $(this);
                            const $aside = $widget.find('aside');
                            const $title = $aside.find('.widget-title');
                            const $menuContainer = $aside.find('.menu-plan-your-trip-container, .menu-partners-container, .menu-need-help-container, .menu-travellab-group-container');
                            
                            // Remove accordion classes
                            $widget.removeClass('footer-accordion');
                            $title.removeClass('accordion-trigger active');
                            $menuContainer.removeClass('accordion-content');
                            
                            // Show all content and remove handlers
                            $menuContainer.show().removeAttr('style');
                            $title.off('click.accordion').css('cursor', 'auto');
                        });
                    }
                }
                
                // Initialize on page load
                setupAccordions();
                
                // Re-initialize on window resize with debouncing
                let resizeTimer;
                $(window).on('resize', function() {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function() {
                        setupAccordions();
                    }, 250);
                });
            }
            
            // Initialize footer accordions
            initFooterAccordions();
        }

    })

